import {EventEmitter} from '@angular/core';
import {AbstractDialogModel} from '@shared/dialogs/model/abstract-dialog.model';
import {PopupTypeEnum} from '@core/enums/popup-type.enum';

export function createClickEventForPopUp(nodes: NodeList, openDialog: EventEmitter<AbstractDialogModel>, indicationId: string): void {
    nodes.forEach((item: any) => {
        const idAttribute = item.getAttribute('id');
        const typeAttribute = item.getAttribute('class');

        if (idAttribute != null) {
            const id = idAttribute;
            const type = typeAttribute === 'multimedia-link' ? PopupTypeEnum.MULTIMEDIA : PopupTypeEnum.UNIT;
            const title = item.innerHTML;
            item.addEventListener('keyup', (event: KeyboardEvent) => {
                if (event.key === 'Enter' || event.code === 'Space') {
                    openDialog.emit({title, id, type, indicationId});
                    event.stopImmediatePropagation();
                }
            });
            item.addEventListener('click', (event: Event) => {
                openDialog.emit({title, id, type, indicationId});
                event.stopImmediatePropagation();
            });
        }
    });
}
